import { ControlPropertyType } from '../../../enums';

export const IncrementInputProperty = {
  ...ControlPropertyType,
  Min: 'min',
  Max: 'max',
  Step: 'step',
};

export default {
  IncrementInputProperty,
};
